import { Box, Grid, Modal } from "@material-ui/core";
import React from "react";
import { useCatalogCurrent } from "../helper/useCatalogCurrent";
import { useState } from "react";
import MaterialTable from "material-table";
import SelectableSearch from "../../base/views/SelectableSearch";
import { getCatalogSuppliers } from "../helper/reportHelper";
import CustomModal from "../../base/views/CustomModal";

function PriceCatalog({ storeId, open, onClose, ...props }) {
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [search, setSearch] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState({
    id: 0,
    optionname: "",
  });
  const [supplierData, setSupplierData] = useState({ load: false, values: [] });

  const { catalog, isLoading } = useCatalogCurrent(
    storeId,
    selectedSupplier.id,
    search,
    pageNo,
    pageSize
  );

  const loadingSupplier = () => {
    setSupplierData({ ...supplierData, load: true });
    getCatalogSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.name,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {})
      .finally(() => {
        setSupplierData((prev) => ({ ...prev, load: false }));
      });
  };

  return (
    <CustomModal open={open} onClose={onClose} {...props}>
      <Grid style={{ padding: 20 }} container>
        <Grid item xs={6}>
          <SelectableSearch
            required
            value={selectedSupplier}
            data={supplierData}
            name="supplier"
            label="Supplier"
            id="supplier"
            autoFocus={true}
            loading={loadingSupplier}
            onChangeEvent={(e, value) => setSelectedSupplier(value)}
            variantType="standard"
          ></SelectableSearch>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "end",
            fontSize: 16,
            fontWeight: "500",
          }}
        >
          {catalog[0]?.total_count && catalog[0]?.total_count + " items"}
        </Grid>
      </Grid>{" "}
      <MaterialTable
        style={{
          width: "100%",
          minWidth: 600,
          height: "70vh",
          overflow: "scroll",
        }}
        title={"Price Catalog"}
        columns={[
          {
            title: "NDC",
            field: "ndc",
          },
          {
            title: "UPC",
            field: "upc",
          },
          { title: "Description", field: "desc" },
          { title: "Pack Size", field: "pack_quantity" },
          { title: "Form", field: "form" },
          {
            title: "Catalog Price",
            field: "price",
            render: (row) =>
              Number(row.price).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              }),
          },
        ]}
        page={pageNo}
        onChangePage={(newPage) => setPageNo(newPage)}
        onChangeRowsPerPage={(pSize) => {
          setPageNo(0);
          setPageSize(pSize);
        }}
        isLoading={isLoading}
        data={catalog}
        totalCount={catalog[0]?.total_count || 0}
        onSearchChange={(text) => {
          setPageNo(0);
          setSearch(text);
        }}
        options={{
          searchText: search,
          paging: true,
          pageSize: pageSize,
          pageSizeOptions: [10, 25, 50, 100],
        }}
      />
    </CustomModal>
  );
}

export default PriceCatalog;
